<template>
  <div class="w-screen h-screen flex flex-col">
    <div class="bg-b2c-red-300 h-40 w-full flex">
      <transition name="slide">
        <div
          class="flex justify-start text-white cursor-pointer items-center text-sm pl-6" @click="toggleMenu;$emit('close-menu')">X
        </div>
      </transition>
      <router-link class="flex flex-col justify-center w-full items-center mr-8" to="/" @click.native="$emit('close-menu')">
        <salvi-music-shop-white-logo></salvi-music-shop-white-logo>
      </router-link>
    </div>
    <nav aria-label="Menu links"
      class="bg-white pt-10 pb-20 md:pt-24 justify-between md:justify-start h-screen w-screen text-2xl font-serif flex flex-col items-center uppercase"
    >
      <div class="md:hidden flex justify-center pb-16">
        <search :inMenu="true" :aria-label="$t('menu.search')" @found="$emit('close-menu')"></search>
      </div>
      <router-link to="/configurator" @click.native="$emit('close-menu')" class="pb-16">
        {{ $t('menu.configurator-string') }}
      </router-link>
      <router-link class="pb-16"
        v-for="category in productCategories" :key="category.id"
        :to="'/product-categories/'+category.slug.toLowerCase()"
        @click.native="$emit('close-menu')">
          {{ category.name }}
      </router-link>
    </nav>
  </div>
</template>

<script>

import SalviMusicShopWhiteLogo from '@/components/graphics/SalviMusicShopWhiteLogo.vue';
import ProductService from '@/services/ProductService';
import Search from '@/components/graphics/Search.vue';

import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      openAccountMenu: false,
      showSearchInput: false,

      productCategories: [],
    };
  },

  computed: {
    ...mapGetters({
      authenticated: ['auth/authenticated'],
      changedLocale: 'auth/changedLocale',
    }),
  },

  components: {
    SalviMusicShopWhiteLogo,
    Search,
  },

  watch: {
    changedLocale() {
      this.getProductCategories();
    },
  },

  created() {
    this.getProductCategories();
  },

  methods: {
    ...mapActions({
      toggleMenu: 'toggleMenu',
    }),

    getProductCategories() {
      this.productCategories = [];
      ProductService.getProductCategoriesForHomepage().then(({ data }) => {
        this.productCategories = data;
      });
    },

    OpenSearchInput() {
      this.showSearchInput = !this.showSearchInput;
    },

    closeSearchInput() {
      this.showSearchInput = false;
    },
  },
};
</script>

<style lang="css" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 0.4s ease-in 0s;
}
</style>
